import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
/**
 * 入力選択カラム
 *【内容:content:string】
 *【選択候補:items:{label: string, value: string}[]】
 *【ミスマッチ内容:mismatchWord:string】
 *【非活性:disabled:boolean】
 *【ミスマッチクリア:mismatchClear:boolean】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-selector-input-column',
  templateUrl: './selector-input-column.html',
  styles: [`
    sg-selector-input-field {
      width: unset;
    }
  `]
})
export class SelectorInputColumn extends BaseWidget {
  /**
   * 項目添字
   */
  @Input() index:number

  /**
   * リスト内容
   */
  @Input() records:any[]

  /**
   * 内容の表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * 内容に対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * 内容
   */
  @Input() content:string

  /**
   * 選択候補
   */
  @Input() items:{label: string, value: string}[]

  /**
   * ミスマッチ内容
   */
  @Input() mismatchWord:string

  /**
   * 非活性
   */
  @Input() disabled:boolean

  /**
   * ミスマッチクリア
   */
  @Input() mismatchClear:boolean

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  get htmlId():string {
    return `${this.id}[${this.index}]`
  }
  get options() {
    const v = {
        options: !!this.items ? this.items : [],
        defaultValue: ""
    }
    return v;
  }
  /**
   * 変更イベント
   * @param data 
   */
  onChange(event, index) {
    let data = event.target ? event.target.value : event.value
    if (!!this.mismatchClear) {
      if (data !== "" && this.items.findIndex(i => i.value === data) === -1) {
        data = ''
        event.target.value = ''
        this.store.dispatch(this.actionCreator.showToast(
          (viewModel:ViewModel) => ('No data found.'),
          (viewModel:ViewModel) => ('alert'),
          {id:this.id, type:"change", source: event},
          'show toast message when no data found'
        ))
      }
    }
  
    if (this.content !== data) {
      this.content = data;
      this.store.dispatch(this.actionCreator.updateViewModel(
        this.viewModelPath,
        (m) => this.content,
        {id:this.id, type:"change", source:new Event("change")},
        `update by ${this.id}`,
      ))
      this.records[index]['_changed'] = true
      const selectedItem = this.items.find(e => e.value === data)
      const content = !!selectedItem ? selectedItem.label : ''
      this.eventHub.next({
        id: this.id,
        type: 'change',
        source: {},
        content: content,
        index: index
      })
    }
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/table/selector-input-column/selector-input-column.component.ts